import { HTMLAttributes, useMemo, useState } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'
// import Spinner from '@/components/base/spinner'
import Typography from '@/components/base/typography'

import { cn } from '@/lib/utils'

export type TheForkWidgetProps = HTMLAttributes<HTMLElement> &
  Partial<{
    widget_terms: string
    widget_privacy: string
    widget_link: string
  }>

const TheForkWidget = ({
  widget_terms,
  widget_privacy,
  widget_link,
  ...props
}: TheForkWidgetProps) => {
  const [termsChecked, setTermsChecked] = useState(false)
  const [privacyChecked, setPrivacyChecked] = useState(false)
  const needsTheForkWidget = useMemo(
    () => termsChecked && privacyChecked,
    [termsChecked, privacyChecked]
  )

  return (
    <Section {...props}>
      <Container>
        <Grid className="gap-y-[3.2rem]">
          <div className="col-span-4 md:col-span-6 lg:col-span-8 lg:col-start-3">
            <div className="mx-auto grid max-w-[48rem] gap-y-[1.6rem]">
              <label className="flex items-start space-x-[1rem] text-[#5F6368]">
                <input
                  type="checkbox"
                  checked={termsChecked}
                  className="mt-[0.15rem] h-[1.3rem] w-[1.3rem]"
                  onChange={(event) => setTermsChecked(event.target.checked)}
                />
                <Typography variant="small">{widget_terms}</Typography>
              </label>
              <label className="flex items-start space-x-[1rem] text-[#5F6368]">
                <input
                  type="checkbox"
                  checked={privacyChecked}
                  className="mt-[0.15rem] h-[1.3rem] w-[1.3rem]"
                  onChange={(event) => setPrivacyChecked(event.target.checked)}
                />
                <Typography variant="small">{widget_privacy}</Typography>
              </label>
            </div>
          </div>
          {needsTheForkWidget ? (
            <div
              className={cn(
                'col-span-4 md:col-span-6 lg:col-span-10 lg:col-start-2',
                'relative min-h-[900px] bg-[#E5E4E4]'
              )}
            >
              {/* <div className="absolute left-1/2 top-[8.5rem] -translate-x-1/2">
                <Spinner variant="small" className="[&>svg]:stroke-[#124254]" />
              </div> */}

              <iframe
                src={widget_link}
                className="relative z-10 h-full w-full border-none"
              />
            </div>
          ) : null}
        </Grid>
      </Container>
    </Section>
  )
}

export default TheForkWidget
